import { render, staticRenderFns } from "./BookingImporter.vue?vue&type=template&id=5552d270"
import script from "./BookingImporter.vue?vue&type=script&lang=js"
export * from "./BookingImporter.vue?vue&type=script&lang=js"
import style0 from "./BookingImporter.vue?vue&type=style&index=0&id=5552d270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports